import React, { useState } from "react";
import { collection, addDoc, updateDoc, doc, serverTimestamp } from "firebase/firestore";
// import { db } from "./firebaseConfig";
import db from '../../firebase/firebase'
import { useLocation, useNavigate } from "react-router-dom";

export default function AddCase() {

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const editModel = location.state?.model || null;
    const isEditMode = !!editModel;

    const [title, setTitle] = useState(editModel?.title || "");
    const [description, setDescription] = useState(editModel?.description || "");
    const [questions, setQuestions] = useState(editModel?.questions || [""]);
    const [answers, setAnswers] = useState(editModel?.answers || [""]);

    // ---- helpers ----
    const updateArray = (setter, arr, index, value) => {
        const copy = [...arr];
        copy[index] = value;
        setter(copy);
    };

    const addField = (setter, arr) => setter([...arr, ""]);
    const removeField = (setter, arr, index) =>
        setter(arr.filter((_, i) => i !== index));

    const submitCase = async () => {
        if (!title || !description) {
            alert("Title and description are required");
            return;
        }

        setLoading(true);

        const payload = {
            title,
            description,
            questions: questions.filter(q => q.trim()),
            answers: answers.filter(a => a.trim()),
            updatedAt: serverTimestamp()
        };

        try {
            if (isEditMode) {
                // ✏️ EDIT
                await updateDoc(doc(db, "cases", editModel.id), payload);
                // alert("✅ Case updated successfully");
            } else {
                // ➕ ADD
                await addDoc(collection(db, "cases"), {
                    ...payload,
                    createdAt: serverTimestamp()
                });
                // alert("✅ Case added successfully");
            }
            navigate("/admin/cases");
        } catch (err) {
            console.error(err);
            alert("❌ Failed to save case");
        }

        setLoading(false);
    };


    return (
        <div style={styles.container}>
            <h2>{isEditMode ? "Edit Case" : "Add New Case"}</h2>

            {/* Title */}
            <input
                style={styles.input}
                placeholder="Case Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
            />

            {/* Description */}
            <textarea
                style={styles.textarea}
                placeholder="Case Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
            />

            {/* Questions */}
            <h4>Questions</h4>
            {questions.map((q, i) => (
                <div key={i} style={styles.row}>
                    <input
                        style={styles.input}
                        placeholder={`Question ${i + 1}`}
                        value={q}
                        onChange={(e) =>
                            updateArray(setQuestions, questions, i, e.target.value)
                        }
                    />
                    {questions.length > 1 && (
                        <button onClick={() => removeField(setQuestions, questions, i)}>
                            ❌
                        </button>
                    )}
                </div>
            ))}
            <button
                style={{ marginTop: 10, fontSize: 16, backgroundColor: 'gray', color: 'white', borderWidth: 0, padding: 5, borderRadius: 5, width: 150 }}
                onClick={() => addField(setQuestions, questions)}>
                + Add Question
            </button>

            {/* Answers */}
            <h4 style={{ marginTop: 20 }}>Answers</h4>
            {answers.map((a, i) => (
                <div key={i} style={styles.row}>
                    <textarea
                        style={styles.textarea}
                        placeholder={`Answer ${i + 1}`}
                        value={a}
                        onChange={(e) =>
                            updateArray(setAnswers, answers, i, e.target.value)
                        }
                    />
                    {answers.length > 1 && (
                        <button onClick={() => removeField(setAnswers, answers, i)}>
                            ❌
                        </button>
                    )}
                </div>
            ))}
            <button
                style={{ marginTop: 10, fontSize: 16, backgroundColor: 'gray', color: 'white', borderWidth: 0, padding: 5, borderRadius: 5, width: 150 }}
                onClick={() => addField(setAnswers, answers)}>
                + Add Answer
            </button>

            <br /><br />

            <button
                style={{ marginTop: 0, fontSize: 16, backgroundColor: 'green', color: 'white', borderWidth: 0, padding: 5, borderRadius: 5, width: 300, height: 40 }}
                onClick={submitCase} disabled={loading}>
                {loading ? "Saving..." : "Save Case"}
            </button>
        </div>
    );
}

const styles = {
    container: {
        maxWidth: 700,
        margin: "40px auto",
        padding: 20,
        border: "1px solid #ddd",
        borderRadius: 8,
        fontFamily: "sans-serif",
    },
    input: {
        width: "100%",
        padding: 10,
        marginBottom: 10,
    },
    textarea: {
        width: "100%",
        padding: 10,
        marginBottom: 10,
        minHeight: 80,
    },
    row: {
        display: "flex",
        gap: 8,
        alignItems: "center",
    },
};
